// foxera-subnav.component.ts
import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  input
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { SubNavItem } from '@foxera/core/interfaces/sideNav.interface';

@Component({
  selector: 'foxera-subnav',
  templateUrl: './foxera-subnav.component.html',
  styleUrls: ['./foxera-subnav.component.css'],
  imports: [RouterLink, CommonModule],

})
export class FoxeraSubnavComponent implements OnChanges {
  @Input() subNavItems: SubNavItem[] = [];
  @Input() indicatorClass: string = 'blur-container bg-opacity-20'; // Default classes
  readonly activeSubItem = input<SubNavItem | null>(null);
  @Output() activeItemIndexChange = new EventEmitter<number>();

  activeItem: SubNavItem | null = null;
  indicatorPosition: string = '0px';
  indicatorWidth: string = '0px';

  constructor(private router: Router) { }

  ngOnInit(): void {
    // Set initial active item based on input from parent
    this.setActiveItemFromRoute();

    // Listen for window resize (which triggers media queries and font changes)
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  ngOnChanges(): void {
    // When subNavItems change, re-evaluate active item
    this.setActiveItemFromRoute();
  }

  private setActiveItemFromRoute(): void {
    if (this.subNavItems.length === 0) return;

    // Always prioritize the activeSubItem passed from parent (navbar)
    // The navbar component is the source of truth for active subnav items
    const activeSubItem = this.activeSubItem();
    if (activeSubItem && this.subNavItems.includes(activeSubItem)) {
      this.activeItem = activeSubItem;
    } else if (this.subNavItems.length > 0) {
      // Only use route-based detection if no activeSubItem is provided from parent
      const currentUrl = this.router.url;
      const matchedItem = this.subNavItems.find(
        (item) =>
          currentUrl === item.link || currentUrl.startsWith(item.link + '/')
      );
      this.activeItem = matchedItem || this.subNavItems[0];
    }

    setTimeout(() => {
      this.setIndicatorPosition();
      // Emit active index
      const activeIndex = this.subNavItems.findIndex(
        (subItem) => subItem === this.activeItem
      );
      this.activeItemIndexChange.emit(activeIndex);
    }, 100);
  }

  ngAfterViewInit(): void {
    this.setIndicatorPosition();
  }

  ngOnDestroy(): void {
    // Clean up event listener
    window.removeEventListener('resize', this.handleResize.bind(this));
  }

  private handleResize(): void {
    // Debounce to avoid excessive calculations
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.setIndicatorPosition();
    }, 200);
  }

  private resizeTimeout: any;

  setActive(item: SubNavItem): void {
    if (this.activeItem !== item) {
      this.activeItem = item;
      this.setIndicatorPosition();

      // Emit the index of the active item
      const activeIndex = this.subNavItems.findIndex(
        (subItem) => subItem === item
      );
      this.activeItemIndexChange.emit(activeIndex);
    }
  }

  setIndicatorPosition(): void {
    setTimeout(() => {
      const activeElement = document.querySelector('.subnav-item.active');
      if (activeElement) {
        const offsetLeft = (activeElement as HTMLElement).offsetLeft;
        const width = (activeElement as HTMLElement).offsetWidth;

        this.indicatorPosition = `${offsetLeft}px`;
        this.indicatorWidth = `${width}px`;
      }
    }, 50);
  }
}

